import React, { useState, useEffect } from "react";
import { HeaderConfig } from "./config";
import CustomTable from "../../../../core/custom-table";
import ServiceInfoFilters from "./service-bulletins-filters";
import {
  HTTP_METHODS,
  invokeApi,
  plainApi,
} from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import { toast } from "react-toastify";
import CreateServiceInformation from "./create-service-bulletin";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CustomButtonComponent from "../../../../core/custom-button";
import DeleteModal from "../../../../components/delete-modal";
import AttachmentModal from "../../../../components/attachment-modal";
import { PAGE_LIMIT } from "../../../../utils";

const ServiceBulletinsAdmin = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [editData, setEditData] = useState({});
  const [isDelete, setIsDelete] = useState({ isOpen: false, data: {} });
  const [filters, setFilters] = useState({
    page: 1,
    limit: PAGE_LIMIT,
    sortBy: "-createdAt",
  });
  const [downloadAttachment, setDownloadAttachment] = useState({
    isOpen: false,
    data: [],
  });
  const ClickHandler = (type, data) => {
    switch (type) {
      case "DOWNLOAD":
        setDownloadAttachment({
          isOpen: true,
          data: [...data.attachments],
        });
        break;
      case "EDIT":
        setIsCreate(true);
        setEditData(data);
        break;
      case "DELETE":
        setIsDelete({ isOpen: true, data: data });
        break;
      default:
        break;
    }
  };
  const deleteHandler = () => {
    invokeApi(
      HTTP_METHODS.DELETE,
      `${HOSTNAME}${REST_URLS.SERVICE_BULLETINS}/${isDelete?.data?.id}`
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          toast.success("Deleted Successfully");
          setIsDelete({ isOpen: false, data: {} });
          loadData(filters);
        }
      })
      .catch((err) => console.error(err));
  };
  const downloadReports = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.SERVICE_BULLETINS}`,
      null,
      { download: "TRUE" },
      "blob"
    )
      .then((res) => {
        if (!res.message) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Service bulletin.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      })
      .catch((err) => console.error(err));
  };
  const loadData = (filters) => {
    const payload = { ...filters, approvalStatus: "APPROVED" };
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.SERVICE_BULLETINS}`,
      null,
      payload
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          setData(res);
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  useEffect(() => {
    loadData(filters);
  }, []);
  return (
    <div className="page-body">
      <div className=" view-detailed-ticket">
        {isCreate && (
          <IconButton
            onClick={() => {
              setIsCreate(false);
              setEditData({});
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        <div>
          <p className="tab-name">Literature</p>
          <p className="section-name">Service Bulletins</p>
        </div>
      </div>
      {isCreate ? (
        <CreateServiceInformation
          loadData={loadData}
          setIsCreate={setIsCreate}
          editData={editData}
        />
      ) : (
        <div>
          <div className="create-con">
            <p className="primary-text">Workshop Bulletins Index</p>
            <div>
              <CustomButtonComponent
                variant="contained"
                color="success"
                sx={{ mr: 2 }}
                onClick={downloadReports}
              >
                Download
              </CustomButtonComponent>
              <CustomButtonComponent
                variant="contained"
                color="primary"
                onClick={() => setIsCreate(true)}
              >
                Create Service Bulletin
              </CustomButtonComponent>
            </div>
          </div>
          <div className="si-hide-mobile">
            <CustomTable
              header={HeaderConfig}
              data={data.results || []}
              pageCount={data.totalPages}
              filters={filters}
              onClick={ClickHandler}
              onChange={(page) => {
                setFilters({
                  ...filters,
                  page,
                });
                loadData({
                  ...filters,
                  page,
                });
              }}
              filterCom={<ServiceInfoFilters loadData={loadData} />}
              isLoading={isLoading}
            />
          </div>
        </div>
      )}
      {isDelete?.isOpen && (
        <DeleteModal
          deleteHandler={deleteHandler}
          onClose={() => {
            setIsDelete({ isOpen: false, data: {} });
          }}
        />
      )}

      {downloadAttachment?.isOpen && (
        <AttachmentModal
          attachments={downloadAttachment?.data}
          onClose={() => setDownloadAttachment({ isOpen: false, data: [] })}
        />
      )}
    </div>
  );
};
export default ServiceBulletinsAdmin;
